// index.js
import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import App from "./App";
import store from "./Store"; // Ensure the file path and casing are correct
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';


import axios from "axios";

//  axios.defaults.baseURL = "https://daladamaligawa.dockyardsoftware.com/";
axios.defaults.baseURL = "https://daladamaligawatest.dockyardsoftware.com/";


//Test and Prod servers spell some response fields differently making both spellings available so every page works against either server
axios.interceptors.response.use((res) => {
  const d = res?.data;
  if (d && typeof d === "object" && !Array.isArray(d)) {
    if (d.ResultSet !== undefined && d.resultSet === undefined) d.resultSet = d.ResultSet;
    if (d.resultSet !== undefined && d.ResultSet === undefined) d.ResultSet = d.resultSet;
    if (d.statusCode !== undefined && d.StatusCode === undefined) d.StatusCode = d.statusCode;
    if (d.StatusCode !== undefined && d.statusCode === undefined) d.statusCode = d.StatusCode;
  }
  return res;
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  
  <Provider store={store}>
    <App />
  </Provider>
);
